import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import config from "../../../config.json";
import axios from "axios";

const columns = [
    { id: "name", label: "Event Name", minWidth: 220 },
    { id: "day", label: "Day", minWidth: 120 },
    { id: "hour", label: "Hour", minWidth: 120 },
    { id: "duration", label: "Duration", minWidth: 140 },
    { id: "reward", label: "Reward", minWidth: 220 },
];

export const EventsTable = () => {
    const apiEndPoint = config.apiEndPoint + "info/events";

    const [events, setEvents] = React.useState([]);

    React.useEffect(() => {
        axios
            .get(apiEndPoint)
            .then(({ data }) => setEvents(data));
    }, []);

    return (
        <Box>
            <Paper
                elevation={0}
                sx={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "24px",
                    border: "1px solid rgba(0,0,0,0.06)",
                    background: "#fff",
                    boxShadow:
                        "0 15px 40px rgba(0,0,0,0.05)",
                }}
            >
                <TableContainer
                    sx={{
                        maxHeight: "70vh",
                        overflowX: "auto",
                    }}
                >
                    <Table stickyHeader aria-label="events table">
                        {/* HEADER */}
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        sx={{
                                            minWidth:
                                                column.minWidth,
                                            background:
                                                "#111",
                                            color: "#D4A437",
                                            fontWeight: "bold",
                                            fontSize: {
                                                xs: "13px",
                                                md: "15px",
                                            },
                                            borderBottom:
                                                "1px solid rgba(255,255,255,0.08)",
                                            py: 2.5,
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        {/* BODY */}
                        <TableBody>
                            {events.length > 0 ? (
                                events.map((row, index) => (
                                    <TableRow
                                        hover
                                        key={row.code}
                                        sx={{
                                            transition: "0.2s",
                                            background:
                                                index % 2 === 0
                                                    ? "#fff"
                                                    : "#fafafa",
                                            "&:hover": {
                                                background:
                                                    "#f5f5f5",
                                            },
                                        }}
                                    >
                                        <TableCell
                                            sx={{
                                                color: "#111",
                                                fontWeight: 700,
                                                fontSize: {
                                                    xs: "14px",
                                                    md: "15px",
                                                },
                                                py: 2.5,
                                                borderBottom:
                                                    "1px solid rgba(0,0,0,0.05)",
                                            }}
                                        >
                                            {row.eventName}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                color: "#666",
                                                fontWeight: 500,
                                                fontSize: {
                                                    xs: "13px",
                                                    md: "14px",
                                                },
                                                borderBottom:
                                                    "1px solid rgba(0,0,0,0.05)",
                                            }}
                                        >
                                            {row.day}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                color: "#666",
                                                fontWeight: 500,
                                                fontSize: {
                                                    xs: "13px",
                                                    md: "14px",
                                                },
                                                borderBottom:
                                                    "1px solid rgba(0,0,0,0.05)",
                                            }}
                                        >
                                            {row.hour}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                color: "#666",
                                                fontWeight: 500,
                                                fontSize: {
                                                    xs: "13px",
                                                    md: "14px",
                                                },
                                                borderBottom:
                                                    "1px solid rgba(0,0,0,0.05)",
                                            }}
                                        >
                                            {row.min}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                color: "#D4A437",
                                                fontWeight: "bold",
                                                fontSize: {
                                                    xs: "13px",
                                                    md: "14px",
                                                },
                                                borderBottom:
                                                    "1px solid rgba(0,0,0,0.05)",
                                            }}
                                        >
                                            {row.reward}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell
                                        colSpan={5}
                                        sx={{
                                            py: 8,
                                            textAlign: "center",
                                            background:
                                                "#fff",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#999",
                                                fontSize: "16px",
                                                fontWeight: 500,
                                            }}
                                        >
                                            Loading events...
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};